<template>
  <div>
      <common-news :categoryList="categoryList" title="信息公开"></common-news>
  </div>
</template>
<script>
import commonNews from '@/components/common-news.vue';
export default {
components:{commonNews},
data() {
    return {
    categoryList:[{
    channelId:177,
    name:"政策法规",
    isActive:false,
    children: [
            { channelId: 192, title: "产业政策" },
            { channelId: 193, title: "法律规章" },
          ],

    },{channelId:178,name:"公示公告"},
    {channelId:181,name:"国标地标",
    isActive:false,
    children: [
            { channelId: 194, title: "大米标准" },
            { channelId: 195, title: "水质标准" },
            { channelId: 196, title: "食用安全国家标准" },
            { channelId: 197, title: "黄酒标准" },
            { channelId: 198, title: "酒曲标准" },
          ],

    },
    {channelId:179,
    name:"年度数据",
    isActive:false,
    children: [
            { channelId: 188, title: "2021" },
            { channelId: 189, title: "2020" },
            { channelId: 190, title: "2019" },
            { channelId: 191, title: "2018" },
          ],
    },
    {channelId:180,name:"黑白榜"}
    ]
    }
  },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>
